<section class="tags" *ngIf="tags && tags.length; else empty">
	<a class="tag" (click)="setTag(item)" *ngFor="let item of tags">#{{item}}</a>
</section>
<ng-template #empty>
	<section class="tags">
		<p class="tag empty">EMPTY</p>
	</section>
</ng-template>
